<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6>
            <v-card class="elevation-12">
              <v-toolbar color="orange" dark>
                <v-toolbar-title>Items Details</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text v-if="user.data.item_changed">
                <v-form >
                  <div v-for="item in items" v-if="item.name !== 'Accommodation' && item.name !== 'Booth Area' && (item_key = [item.id, item.min_quantity].join(''))" :key="item_key" style="margin-bottom: 20px;">
                    <p class="title">{{ item.name }} <span v-if="item.unit">({{ item.unit }})</span></p>
                    <!-- {{ item.id + ' : ' + item.name }} -->
                    <NumberInputSpinner :id="item.id" :value="item.min_quantity" :min="item.min_quantity" :max="item.max_quantity" :step="1" :integerOnly="true" @cart="addToCart" :disabled="item.min_quantity == item.max_quantity" />
		                <p class="title mb-3" v-if="item.price != 0" style="margin-top: 7px;">
	                    Price:
                      <span class="badge" v-if="!isNaN((item.min_quantity - item.free_quantity) * item.price)">
                        {{ (user_item[item.id] - item.free_quantity) * item.price }} L.E 
                      </span>
	                    <span class="badge" v-else>0</span>
		                </p>
                  </div>
                </v-form>
                <p v-if="user.data.city_accommodation">
                  The price of your extra "Accommodation" is {{ accommodationPrice }} L.E. You have "{{ accommodationCounter }}" registered members with "Accommodation".
                </p>
                <p>
                  The price of your "Booth Area" is {{ getBoothPrice }} L.E. Your current "Booth Area" {{ boothArea }} &#13217;.
                </p>
                <hr>
                <p class="title text-primary">
                	Total : <span class="badge">{{ totalPrice }} L.E</span>
                </p>
              </v-card-text>
              <v-card-actions>
                
                <v-btn color="primary" left @click.prevent="rollBack" >Previous</v-btn>
                <v-spacer></v-spacer>                
                <v-btn color="success" right @click.prevent="proceed">Next</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app> 
</template>
<script>
  import NumberInputSpinner from '../../elements/Spinner.vue';
  export default {  
    props : ['user','items', 'original_items','cities'],
    components: {
      NumberInputSpinner
    },
    data(){
      return {
        user_item : {},
        accommodationPrice : 0,
        products:[
            
        ],
        accommodation : this.items.find(item => item.name === 'Accommodation'),
        lengthID: this.items.find(item => item.name == 'Booth Length').id,
        widthID: this.items.find(item => item.name == 'Booth Width').id,
        heightID: this.items.find(item => item.name == 'Prototype Height').id,
        weightID: this.items.find(item => item.name == 'Prototype Weight').id,
        areaItem: this.items.find(item => item.name == 'Booth Area'),
        boothArea: 0,
        boothAreaPrice: 0,
      }
    },
    computed : {
      accommodationCounter(){
        let accommodation_count = this.user.data.members.filter(member => member.has_accommodation == true).length
        this.user_item[this.accommodation.id] = accommodation_count;
        return accommodation_count
      },
      getBoothPrice(){
        if (this.user.data.hasOwnProperty('project')) {
          let originalMinLength = this.original_items.find(item => item.name == 'Booth Length').min_quantity;
          let originalMinWidth = this.original_items.find(item => item.name == 'Booth Width').min_quantity;

          this.items.find(item => item.name == 'Booth Length').min_quantity = Math.max(originalMinLength, Math.ceil(this.user.data.project.spec_length))
          this.items.find(item => item.name == 'Booth Width').min_quantity = Math.max(originalMinWidth, Math.ceil(this.user.data.project.spec_width))
        }
        
        this.user_item[this.widthID] = Math.max(this.items.find(item => item.name == 'Booth Width').min_quantity, this.user_item[this.widthID])
        this.user_item[this.lengthID] = Math.max(this.items.find(item => item.name == 'Booth Length').min_quantity, this.user_item[this.lengthID])
        this.user_item[this.areaItem.id] = this.user_item[this.widthID] * this.user_item[this.lengthID];

        this.boothArea = this.user_item[this.areaItem.id];
        this.boothAreaPrice = (this.boothArea - this.areaItem.free_quantity) * this.areaItem.price;
        return this.boothAreaPrice
      },
      totalPrice(){
        let total_price = 0;
        //accommodation stage.
        if (this.accommodationCounter && this.user.data.city_accommodation) {
          this.accommodationPrice = ((this.accommodationCounter - (this.user.data.city_accommodation * this.accommodation.free_quantity)) * this.accommodation.price);
          total_price += this.accommodationPrice
          
        }

        Object.keys(this.user_item).forEach(item => {
          let product = this.items.filter(piece => piece.id == item && item != this.widthID && item != this.lengthID && item != this.accommodation.id);
          if (product.length) {
            if (product[0].name == 'Booth Area') {
              this.boothArea = this.user_item[this.widthID] * this.user_item[this.lengthID]
              this.boothAreaPrice = (this.boothArea - product[0].free_quantity) * product[0].price
              total_price += this.boothAreaPrice
            } else {
              total_price += (product[0].min_quantity - product[0].free_quantity) * product[0].price;
            }
            
          }
        })

        // products stage.
        this.products.forEach(product => {
          if (product.quantity > product.free) {
            total_price += (product.quantity - product.free) * product.price;
          }
        })

        let in_items = []
        for (let key in this.user_item ) {
          in_items.push({ item_id : parseInt(key) , quantity : this.user_item[key]});
        }
        this.user.data.logistics = in_items;
        this.user.data.total_price = total_price;
        return total_price;
      }
    },
    methods : {
      proceed (){
        let items = []
        for (let key in this.user_item ) {
          items.push({ item_id : parseInt(key) , quantity : this.user_item[key]});
        }
        this.user.data.logistics = items;
        this.$emit('completed',this.user);
      },
      rollBack(){
        this.$emit('rollback',this.user)
      },
      addToCart(id, quantity){
        let item = this.items.filter(item => item.id === id);
        let found = this.products.filter(product => item[0].id === product.id);
        if (quantity <= item[0].min_quantity) {
          quantity = item[0].min_quantity
        }
        if (quantity >= item[0].min_quantity && quantity <= item[0].max_quantity) {
          this.user_item[item[0].id] = quantity;   
        }
        if(quantity > item[0].max_quantity){
          quantity -= 1;
        }
        if (found.length > 0) { 
          found[0].price = item[0].price;
          found[0].id = item[0].id; 
          found[0].quantity = quantity;
          found[0].free = item[0].free_quantity;
          found[0].name = item[0].name;
          let i; 
          this.products.forEach((product, index) => {
           if (product.id === item[0].id)
            i = index 
          })
          this.products[i] = found[0];
        } else {
          this.products.push({ name: item[0].name , free : item[0].free_quantity,quantity:  quantity, price: item[0].price, id: item[0].id });
        }
      }
    },
    created(){
      for (let i = 0 ; i < this.items.length; i++) {
        this.user_item[this.items[i].id] = this.items[i].min_quantity
      }
    },

  };
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Registeration/Items.vue